import { scrollToY } from './scrollToY';

const moduleName = 'form';

export function form() {

    Array.from(document.querySelectorAll('.js-form')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const form = self;
        const button = form.querySelector('.js-form-submit-button');

        form.addEventListener('submit', (event) => {
            event.preventDefault();

            if (!$(form).parsley().isValid()) return;

            const xhr = new XMLHttpRequest();
            const formData = new FormData(form);
            const url = form.getAttribute('action');

            button.disabled = true;
            form.classList.add('_loading');

            xhr.open('POST', url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    showFormSuccess(form);
                }
            };
            xhr.send(formData);
        });



        function showFormSuccess(form, speed) {
            const SPEED = speed || 600;

            const formSuccess = form.querySelector('.js-form-success');
            const popupSuccessId = form.dataset.successPopup;

            if (formSuccess) {
                if (form.getBoundingClientRect().top < 0) {
                    scrollToY(form.getBoundingClientRect().top + (window.scrollY || document.body.scrollTop));
                }

                form.style.height = form.offsetHeight + 'px';

                setTimeout(() => {
                    form.style.height = formSuccess.offsetHeight + 'px';
                    form.classList.add('_success');

                    setTimeout(() => {
                        form.style.height = '';
                        resetForm();
                    }, SPEED);
                }, 20);
            } else if (popupSuccessId) {
                popup().open(popupSuccessId);
                resetForm();
            }
        }

        function resetForm() {
            const formEntries = form.querySelectorAll('input[type="text"], input[type="password"], input[type="tel"], input[type="email"], input[type="number"], textarea');

            button.disabled = false;
            form.classList.remove('_loading');
            Array.from(formEntries).forEach((formEntry) => {
                formEntry.value = '';
                triggerEvent(formEntry, 'blur');
            });
        }

        function triggerEvent(element, eventName) {
            let customEvent;

            if (typeof(Event) === 'function') {
                customEvent = new Event(eventName);
            } else {
                customEvent = document.createEvent('Event');
                customEvent.initEvent(eventName, true, true);
            }

            element.dispatchEvent(customEvent);
        }
    });

}